import React from 'react';
import type {UserInstanceModel} from 'src/api/ProactApiClient';
import {isValidArray} from 'src/utilities/objectUtils';
import {SidebarFooterSelect} from './SidebarFooterSelect';

export interface UserInstancesProps {
  instances: UserInstanceModel[];
  selectedInstance?: number;
  onChange: (value: string | null) => void;
  isLoading?: boolean;
}
export const UserInstances: React.FC<UserInstancesProps> = ({
  instances,
  selectedInstance,
  onChange,
  isLoading,
}) => {
  const data =
    instances.length !== 0
      ? instances.map(i => ({value: String(i.id), label: i.name ?? ''}))
      : [{value: '1', label: 'Loading...'}];

  return (
    <SidebarFooterSelect
      label="Instance"
      data={data}
      value={isValidArray(instances) ? String(selectedInstance) : '1'}
      onChange={onChange}
      isLoading={isLoading}
      placeholder={isLoading ? 'Switching...' : undefined}
    />
  );
};
